import { PaginationParams } from "types/general.interface";
import { handleGetRequest, handlePostRequest } from "./http.service";
import { PaginationDataRes } from "types/http.type";
import { Booking, CreateBookingInput, Invoice } from "types/booking.interface";

export interface CreateBookings {
  bookingType?: string;
  message?: string;
  myndaId: string;
}

export const getBookings = async (paginationOptions: PaginationParams) => {
  return await handleGetRequest<PaginationDataRes<Booking[]>>(
    `/admins/bookings?page=${paginationOptions.page}&limit=${paginationOptions.limit}`
  );
};

export const getBookingInvoice = async (booking: string) => {
  return await handleGetRequest<Invoice>(`/admins/bookings/${booking}/invoice`);
};

export const createBooking = async (payload: CreateBookingInput) => {
  return await handlePostRequest<CreateBookingInput, null>(
    `/admins/create-booking`,
    payload
  );
};
